import React from "react";
import { useTranslation } from "react-i18next";
import RoundButton from "../../Buttons/RoundButton";
import classes from "./style.module.scss";

export default function CardRandomGame({
  className = "",
  id = "",
  name = "",
  image = "",
  abilities = null,
  onClick = null,
}: {
  abilities: any;
  name: string | null;
  image: string | null;
  className?: string;
  id: string;
  onClick: any;
}) {
  const { t } = useTranslation();
  className += "  " + classes.CardRandomGame;
  return (
    <section className={classes.RandomGameArea}>
      <article className={className} key={id}>
        <div
          className={classes.GameImg}
          style={{ backgroundImage: `url(${image})` }}
        />
        <div className={classes.GameInfos}>
          <h1 className={classes.TitleHuge}>
            {"Está com dúvida do que jogar?"}
          </h1>
          <h1 className={classes.Title}>{name}</h1>
          <h2 className={classes.SubTitle}>{t("global.you_will_training")}:</h2>
          <ul>
            {abilities &&
              abilities.map((ability: string) => (
                <li className={classes.Info} key={ability}>
                  - {ability}
                </li>
              ))}
          </ul>
          <div className={classes.BtnsArea}>
            <RoundButton
              text={t("global.play")}
              title={t("global.open_game_modal")}
              onClick={onClick}
            />
          </div>
        </div>
      </article>
    </section>
  );
}
